
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Upload, Award, Calendar, AlertCircle } from "lucide-react";
import { Progress } from "@/components/ui/progress";

export const BartenderCertificationsPage = () => {
  const mockCertifications = [
    { 
      id: 1, 
      name: "Responsible Service of Alcohol (RSA)",
      status: "Valid",
      expiry: "May 15, 2024",
      progress: 65
    },
    { 
      id: 2, 
      name: "Food Handling Certificate",
      status: "Valid",
      expiry: "February 20, 2024",
      progress: 35
    },
    { 
      id: 3, 
      name: "Advanced Mixology Course",
      status: "In Progress",
      progress: 40
    },
  ];

  return (
    <div className="container mx-auto p-6 max-w-6xl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Certifications</h1>
        <Button>
          <Upload className="mr-2 h-4 w-4" />
          Upload New Certificate
        </Button>
      </div>

      <div className="grid gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Your Certifications</CardTitle>
            <CardDescription>
              Manage your certifications and track expiration dates
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              {mockCertifications.map((cert) => (
                <div key={cert.id} className="p-4 border rounded-lg">
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex items-center gap-3">
                      <Award className="h-6 w-6 text-blue-500" />
                      <div>
                        <h3 className="font-semibold">{cert.name}</h3>
                        {cert.expiry && (
                          <div className="flex items-center gap-1 text-sm text-muted-foreground">
                            <Calendar className="h-4 w-4" />
                            <span>Expires: {cert.expiry}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      cert.status === "Valid" ? "bg-green-100 text-green-800" :
                      cert.status === "In Progress" ? "bg-blue-100 text-blue-800" :
                      "bg-red-100 text-red-800"
                    }`}>
                      {cert.status}
                    </span>
                  </div>
                  
                  {cert.status === "In Progress" && (
                    <div className="mt-4">
                      <div className="flex justify-between mb-1">
                        <span className="text-sm">Progress</span>
                        <span className="text-sm">{cert.progress}%</span>
                      </div>
                      <Progress value={cert.progress} className="h-2" />
                    </div>
                  )}
                  
                  <div className="mt-4 flex justify-end gap-2">
                    {cert.status === "Valid" && (
                      <Button variant="outline" size="sm">Download</Button>
                    )}
                    <Button variant="default" size="sm">
                      {cert.status === "In Progress" ? "Continue Course" : "View Details"}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <AlertCircle className="h-5 w-5 text-amber-500" />
              Recommended Certifications
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 border rounded-lg border-dashed">
                <div className="flex items-center gap-3">
                  <Award className="h-5 w-5 text-purple-500" />
                  <div>
                    <h3 className="font-semibold">Advanced Cocktail Techniques</h3>
                    <p className="text-sm text-muted-foreground">
                      Elevate your bartending skills with this advanced course
                    </p>
                  </div>
                </div>
                <Button variant="outline" size="sm">Learn More</Button>
              </div>
              
              <div className="flex items-center justify-between p-4 border rounded-lg border-dashed">
                <div className="flex items-center gap-3">
                  <Award className="h-5 w-5 text-purple-500" />
                  <div>
                    <h3 className="font-semibold">Bar Management Essentials</h3>
                    <p className="text-sm text-muted-foreground">
                      Learn essential skills for managing successful bar operations
                    </p>
                  </div>
                </div>
                <Button variant="outline" size="sm">Learn More</Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
